import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function GalleryModal({ isOpen, images, currentIndex, onClose, onPrev, onNext }) {
  const { language } = useLanguage();
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !images || images.length === 0) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-navy-950/95 p-4 backdrop-blur-sm transition-opacity duration-300"
      onClick={handleOverlayClick}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 text-offwhite hover:text-petrol text-2xl transition-colors p-2 focus:outline-none"
        aria-label={language === 'da' ? 'Luk galleri' : language === 'en' ? 'Close gallery' : 'Galerie schließen'}
      >
        <i className="fa-light fa-xmark text-3xl"></i>
      </button>

      {/* Navigation - Prev */}
      {images.length > 1 && (
        <button
          onClick={onPrev}
          className="absolute left-4 md:left-8 text-offwhite hover:text-petrol text-3xl transition-colors p-3 bg-navy-900/50 rounded-full hover:bg-navy-800 focus:outline-none"
          aria-label={language === 'da' ? 'Forrige billede' : language === 'en' ? 'Previous image' : 'Vorheriges Bild'}
        >
          <i className="fa-light fa-chevron-left"></i>
        </button>
      )}

      {/* Image Container */}
      <div className="max-w-5xl max-h-[80vh] flex flex-col items-center justify-center">
        <img
          src={images[currentIndex]}
          alt={language === 'da' ? `Galleri billede ${currentIndex + 1}` : language === 'en' ? `Gallery image ${currentIndex + 1}` : `Galeriebild ${currentIndex + 1}`}
          className="max-w-full max-h-[75vh] object-contain rounded-lg shadow-2xl select-none"
        />
        <p className="text-offwhite/70 mt-4 text-sm font-sans tracking-wide">
          {language === 'da' ? `Billede ${currentIndex + 1} af ${images.length}` : language === 'en' ? `Image ${currentIndex + 1} of ${images.length}` : `Bild ${currentIndex + 1} von ${images.length}`}
        </p>
      </div>

      {/* Navigation - Next */}
      {images.length > 1 && (
        <button
          onClick={onNext}
          className="absolute right-4 md:right-8 text-offwhite hover:text-petrol text-3xl transition-colors p-3 bg-navy-900/50 rounded-full hover:bg-navy-800 focus:outline-none"
          aria-label={language === 'da' ? 'Næste billede' : language === 'en' ? 'Next image' : 'Nächstes Bild'}
        >
          <i className="fa-light fa-chevron-right"></i>
        </button>
      )}
    </div>
  );
}
